export type Purchase = {
  name: string
  city: string
  state: string
}

/** Compradores de MUESTRA para las notificaciones de compra reciente. */
export const recentPurchases: Purchase[] = [
  { name: 'Mike D.', city: 'Dallas', state: 'Texas' },
  { name: 'Chris K.', city: 'Tampa', state: 'Florida' },
  { name: 'Jen R.', city: 'Columbus', state: 'Ohio' },
  { name: 'Matt T.', city: 'Charlotte', state: 'North Carolina' },
  { name: 'Dave P.', city: 'Phoenix', state: 'Arizona' },
  { name: 'Steve S.', city: 'Nashville', state: 'Tennessee' },
  { name: 'Angela B.', city: 'Atlanta', state: 'Georgia' },
  { name: 'Tom W.', city: 'Sacramento', state: 'California' },
  { name: 'Brian G.', city: 'Oklahoma City', state: 'Oklahoma' },
  { name: 'Kevin D.', city: 'Louisville', state: 'Kentucky' },
  { name: 'Paul H.', city: 'St. Louis', state: 'Missouri' },
  { name: 'Sara L.', city: 'Birmingham', state: 'Alabama' },
]
